import { resolveMoodleTrainingPartErrorMessage } from './moodleTrainingPartErrors';

const isLikelyTranslationKey = value =>
  typeof value === 'string' && value.includes('.') && /^[A-Za-z0-9_.-]+$/.test(value);

const translateIfExists = (key, t) => {
  if (typeof t !== 'function') {
    return key;
  }
  const translated = t(key);
  return translated !== key ? translated : null;
};

const resolveSingleMessage = (message, t, fallbackMessage) => {
  if (typeof message !== 'string') {
    return fallbackMessage;
  }

  const normalizedMessage = message.trim();
  if (!normalizedMessage) {
    return fallbackMessage;
  }

  const moodleTrainingPartMessage = resolveMoodleTrainingPartErrorMessage(normalizedMessage);
  if (moodleTrainingPartMessage) {
    return moodleTrainingPartMessage;
  }

  if (!isLikelyTranslationKey(normalizedMessage)) {
    return normalizedMessage;
  }

  const translatedMessage = translateIfExists(normalizedMessage, t);
  if (translatedMessage) {
    return translatedMessage;
  }

  return fallbackMessage || normalizedMessage;
};

const resolveApiErrorMessage = (message, { t, fallbackMessage = '' } = {}) => {
  if (Array.isArray(message)) {
    const moodleTrainingPartMessage = resolveMoodleTrainingPartErrorMessage(message);
    if (moodleTrainingPartMessage) {
      return moodleTrainingPartMessage;
    }

    const normalizedMessages = message.map(item => resolveSingleMessage(item, t, '')).filter(Boolean);

    if (normalizedMessages.length) {
      return normalizedMessages.join(', ');
    }
    return fallbackMessage;
  }

  return resolveSingleMessage(message, t, fallbackMessage);
};

export default resolveApiErrorMessage;
